import { render } from "./JoinUs.vue?vue&type=template&id=01dbf6e4"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__